module.exports = "<app-header></app-header>\n\n  <router-outlet></router-outlet>\n\n\n<app-footer></app-footer>"